"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _QuestionWithRange = _interopRequireDefault(require("./QuestionWithRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var QuestionWithMulti = function QuestionWithMulti(_ref) {
  var question = _ref.question,
    selections = _ref.selections,
    onUpdate = _ref.onUpdate;
  var subQuestions = question.multi;
  return subQuestions.map(function (subQuestion, index) {
    var _subQuestion$rangeCho;
    return !((_subQuestion$rangeCho = subQuestion.rangeChoices) !== null && _subQuestion$rangeCho !== void 0 && _subQuestion$rangeCho.shouldSkipSegment) ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      key: index,
      style: {
        marginBottom: 30
      }
    }, /*#__PURE__*/_react.default.createElement(_QuestionWithRange.default, {
      question: subQuestion,
      selections: selections,
      selectionIndex: index,
      componentIndex: index,
      onUpdate: onUpdate
    })) : null;
  });
};
var _default = QuestionWithMulti;
exports.default = _default;